import React, { useEffect } from 'react'
import Styles from './NewEditorStyles.module.css';
import { dateFormater, expireDateFormater } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import internal from '../../Icons/internal.svg'
import { ReactComponent as Internal } from "./../../Icons/internal.svg";
import { Checkbox } from 'antd';
import { ReactComponent as CheckBoxIcon } from "../../Icons/checkbox.svg";
import { ReactComponent as CheckBoxSelectedIcon } from "../../Icons/check-square.svg";
import TooltipComp from '../ToolTip/TooltipComp';
// /home/DM-IN-SM-23/react/uknowviews-react/src/Icons/internal.svg
export default function NewBottomBar() {
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "22px",
    fontWeight: "300",
    display: 'flex',
    alignItems: "center",
  };
  const textStyles1 = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    paddingTop: "10px",
    paddingRight: "5px"

  };
  const dispatch = useDispatch();
  const { updateExpirationDateForEditor, updateCheckBoxValForEditor } = bindActionCreators(Actions, dispatch)
  const userState = useSelector(state => state.user);
  const editorState = useSelector(state => state.editor);
  const onClickCheckBox = (flag, key) => {
    let obj = {
      key,
      flag
    }
    updateCheckBoxValForEditor(obj)
  }
  // console.log("user", userState)
  useEffect(() => {
    // console.log("date value", userState.expirationMonths)
    updateExpirationDateForEditor(expireDateFormater(userState.expirationMonths));
  }, [])
  // console.log("date", editorState.expirationDate)
  return (
    <>
      <div className={Styles.container}>
        <div>
          {/* <span style={textStyles1}>Expiration Date: <input type="date" style={{marginLeft:"4px"}} min={dateFormater()} value={editorState.expirationDate} onChange={(e)=>updateExpirationDateForEditor(e.target.value)} className={Styles.dateBox}/></span> */}
          <span style={textStyles1}>
            Expiration Date&nbsp; 
            <input
              type="date"
              style={{ marginLeft: "4px" }}
              min={dateFormater()}
              value={typeof editorState.expirationDate === "boolean"
                ? expireDateFormater(userState.expirationMonths)
                : editorState.expirationDate}
              onChange={(e) => updateExpirationDateForEditor(e.target.value)}
              className={Styles.dateBox}
            />
          </span>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={textStyles}>
            <Checkbox onChange={(e) => onClickCheckBox(e.target.checked, 'internal')} checked={editorState.internalOnly} type="checkbox" />&nbsp;
            <img src={internal} />&nbsp;Internal Only&nbsp;
            {/* <span style={textStyles}>
                  Internal Only
              </span> */}
            {/* <Internal/> */}
            <TooltipComp title="This QA pair will be visible only to Employees and not to Customers & Partners." >
              <i className='fa fa-question-circle tooltip-topics-b' ></i>
            </TooltipComp>

          </div>&nbsp;&nbsp;&nbsp;&nbsp;

          <div style={textStyles}>
            <Checkbox onChange={(e) => onClickCheckBox(e.target.checked, 'isUpdateKB')} checked={editorState.isVizKnowledgeBase} type="checkbox" />&nbsp;<i className="fa fa-lock"></i>&nbsp;Private Answer&nbsp;
            <TooltipComp title='This answer will be visible only to the Seeker who asked the question, and to all Experts.'>
              <i className='fa fa-question-circle tooltip-topics-b'></i>
            </TooltipComp>
          </div>
        </div>
      </div>
    </>
  )
}
